// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import axios from 'axios'
import qs from 'qs'
import Video from 'video.js'
import 'element-ui/lib/theme-chalk/index.css';
import "quill/dist/quill.core.css"
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(ElementUI);
Vue.config.productionTip = false

// (*)生产环境
axios.defaults.baseURL = 'http://backend.000520.top/api'
// (*)本地调试环境
// axios.defaults.baseURL ='http://localhost:8999/changhang'
// 演示环境
// axios.defaults.baseURL = 'http://whmfhy.cn:20096/api'

Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.$video = Video
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js